const parseDate = (dateString) => {
  if (!dateString) return null;

  const parts = dateString.split("/");
  if (parts.length !== 3) return null;

  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);

  if (
    isNaN(day) ||
    isNaN(month) ||
    isNaN(year) ||
    day < 1 ||
    month < 0 ||
    month > 11 ||
    year < 1000
  ) {
    return null;
  }

  return new Date(year, month, day);
};

/**
 * Formats milliseconds since epoch to a readable date string
 * @param {number|string} millisecondsSinceEpoch - Milliseconds since epoch (can be number or string)
 * @returns {string} - Formatted date string (e.g., "12/25/2023") or empty string if invalid
 */
export const formatDateFromMillis = (millisecondsSinceEpoch) => {
  if (!millisecondsSinceEpoch && millisecondsSinceEpoch !== 0) return "";

  try {
    const milliseconds =
      typeof millisecondsSinceEpoch === "string"
        ? parseInt(millisecondsSinceEpoch, 10)
        : millisecondsSinceEpoch;

    if (isNaN(milliseconds)) return "";

    const date = new Date(milliseconds);
    if (isNaN(date.getTime())) return "";

    return date.toLocaleDateString();
  } catch (error) {
    return "";
  }
};

export default parseDate;
